import { Controller } from "@hotwired/stimulus"

// This does not try to reproduce the browser's random multipart boundary byte-for-byte.
// Counting every submitted value plus a deliberately generous per-part allowance, then
// stopping 2 MiB below the proxy cap, keeps the estimate safely on the friendly side.
const MULTIPART_PART_OVERHEAD_BYTES = 512
const MULTIPART_END_OVERHEAD_BYTES = 128

// Keeps an oversized multipart form in the browser instead of letting the proxy replace it
// with a 413 response. This is only the friendly first line: kamal-proxy owns the hard limit
// for clients without JavaScript and requests that do not come from these forms.
export default class extends Controller {
  static values = {
    maxBytes: Number,
    message: String
  }

  validate(event) {
    if (this.estimatedBodyBytes <= this.maxBytesValue) return

    event.preventDefault()
    this.dispatch("rejected", { detail: { message: this.messageValue } })
  }

  get estimatedBodyBytes() {
    const encoder = new TextEncoder()
    let bytes = MULTIPART_END_OVERHEAD_BYTES

    for (const [name, value] of new FormData(this.element).entries()) {
      bytes += MULTIPART_PART_OVERHEAD_BYTES + encoder.encode(name).byteLength
      bytes += value instanceof File
        ? value.size + encoder.encode(value.name).byteLength + encoder.encode(value.type).byteLength
        : encoder.encode(value).byteLength
    }

    return bytes
  }
}
